import * as actionTypes from "../../Action/actionTypes";

const initialState = {
  notification_table: {
    columns: [
      {
        label: 'Time',
        field: 'time',
        sort: 'asc'
      },
      {
        label: 'Title',
        field: 'title',
        sort: 'asc'
      },
      {
        label: 'Description',
        field: 'description',
        sort: 'asc'
      }
    ]
  },
  allnotificationobj: {
    success: true,
    sub_event_id: 1,
    notificationList: [],
  },
  allsponsorobj: {
    success: true,
    sub_event_id: 1,
    sponsorList: [
      {
        "sponsor_id": 1,
        "sponsor_name": "Dialog",
        "img_url": null
      },
      {
        "sponsor_id": 2,
        "sponsor_name": "Ceyentra",
        "img_url": null
      }
    ],
    sponsorCatList: [
      {
        "sponsor_category_id": 1,
        "sponsor_category_name": "Gold Sponsor",
      },
      {
        "sponsor_category_id": 2,
        "sponsor_category_name": "Silver Sponsor",
      }
    ],
    sponsorDetailsList: [
      {
        "sponsor_id": 1,
        "sponsor_category_id": 1,
        "sponsor_category_name": "Gold Sponsor",
        "sponsor_img": null
      },
      {
        "sponsor_id": 2,
        "sponsor_category_id": 2,
        "sponsor_category_name": "Gold Sponsor",
        "sponsor_img": null
      }
    ],
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default reducer;
